module.exports = __webpack_public_path__ + "img/thumbnail_JapaneseRaccoonDog_m_leucistic.459f210a.png";